/* eslint-disable react-refresh/only-export-components */
import React, { type PropsWithChildren, useCallback } from 'react';
import { type AxiosInstance, type AxiosPromise } from 'axios';

import { axiosManager } from '@/api/api-client';

export interface IApiClientContext {
  http: AxiosInstance;
  httpWithAuth: AxiosInstance;
  api: <T>(axiosPromise: AxiosPromise<T>) => Promise<T>;
}

const ApiClientContext = React.createContext<IApiClientContext>({} as never);

export const ApiClientProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const api = useCallback(
    async <T,>(axiosPromise: AxiosPromise<T>) => await axiosPromise.then(({ data }) => data),
    [],
  );

  const value = {
    http: axiosManager.http,
    httpWithAuth: axiosManager.httpWithAuth,
    api,
  };
  return <ApiClientContext.Provider value={value}>{children}</ApiClientContext.Provider>;
};

export const useApiClient = () => {
  const context = React.useContext(ApiClientContext);
  if (!context) {
    throw new Error('useApiClient must be used within ApiClientProvider');
  }
  return context;
};
